import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from '@ipc/ipc-core';
import { Button, RadioButtonGroup, RadioButton } from '@ipc/ipc-components';
import { putImpcEditRequestActionCreator } from '../redux/actions/ImpcEditActions';
import { onLeftMailProcessingCenterChecked } from '../../../common/selection-criteria/operator-impc/redux/actions/OperatorImpcActions';
import { getAssetType } from '../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getLeftCheckedMailProcessingCenters } from '../../../common/user/redux/selectors/UserDataSelectors';

class ImpcEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.location.data.original.centralEntryPoint,
    };
    this.confirm = this.confirm.bind(this);
  }

  handleChange = (e) => {
    this.setState({ selected: e.target.value });
  };

  confirm() {
    this.props.putImpcEditRequestActionCreator(this.props.appContext, this.props.location.data.original.impcCode, this.state.selected);
  }

  render() {
    return (
      <div className="general-content-container">
        <h1 className="title-div">IMPC EDIT</h1>
        <div className="operator-info-div">
          <table className="operator-impc-detail">
            <tbody>
              <tr>
                <td className="selected-impc">
                  Operator
                </td>
                <td className="selected-impc">
                  {this.props.location.data.original.operatorCode}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  IMPC
                </td>
                <td className="selected-impc">
                  {this.props.location.data.original.impcCode}
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  Central Entry Point
                </td>
                <td className="selected-impc">
                  <RadioButtonGroup defaultValue={this.props.location.data.original.centralEntryPoint === true ? 'true' : 'false'} onChange={this.handleChange} row>
                    <RadioButton value="true" label="Yes" />
                    <RadioButton value="false" label="No" />
                  </RadioButtonGroup>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  <Link to={{ pathname: 'impc-details', state: { tableId: 'IMPC_DETAILS_PAGE' } }}>
                    <Button className="primary-button">Cancel</Button>
                  </Link>
                </td>
                <td className="selected-impc">
                  <Link to={{ pathname: 'impc-details', state: { tableId: 'IMPC_DETAILS_PAGE' } }} onClick={this.confirm}>
                    <Button
                      className={`primary-button-${this.props.location.data.original.centralEntryPoint === this.state.selected}`}
                      disabled={this.props.location.data.original.centralEntryPoint === this.state.selected}
                    >
                      Confirm
                    </Button>
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
  };
}
ImpcEditContainer.propTypes = {
  putImpcEditRequestActionCreator: PropTypes.func,
  location: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.string),
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
  onLeftMailProcessingCenterChecked,
  putImpcEditRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ImpcEditContainer);
